/**
 * SASS
 */

import "../sass/frontend.scss";

/**
 * JavaScript
 */

var $ = require("jquery");
window.$ = $;
window.jQuery = $;

require("bootstrap");
require("slick-carousel");
require("magnific-popup");
require("@fortawesome/fontawesome-free/js/all.js");

const AOS = require("aos");
const select2 = require("select2");

// window.addEventListener("load", AOS.refresh());

/**
 * Add here your JavasScript code
 */

var initializeBlock = function ($block) {
  $(".burger-btn").on("click", function () {
    $(".mobile-header").addClass("active");
    $("body").addClass("overflow-hidden");
  });

  $(".close-btn").on("click", function () {
    $(".mobile-header").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  $(".post-cards-slider").each(function () {
    $(this).slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: false,
      arrows: true,
      nextArrow: $(this)
        .parent()
        .parent()
        .find(".post-cards-slider-controls-next"),
      prevArrow: $(this)
        .parent()
        .parent()
        .find(".post-cards-slider-controls-prev"),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  $(".single-work-banner-slider").each(function () {
    $(this).slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: $(this)
        .parent()
        .find(".single-work-banner-slider-controls-prev"),
      nextArrow: $(this)
        .parent()
        .find(".single-work-banner-slider-controls-next"),
    });
  });

  // Initialize each slider with same class
  $(".hs-lrg").each(function () {
    var $slider = $(this).find(".hs-lrg-slider");
    var $dotsContainer = $($slider).parent().find(".hs-lrg-dots");

    $($slider).slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 5000,
      appendDots: $(this).find(".hs-lrg-navigate .hs-lrg-dots"),
      nextArrow: $(this).parent().find(".hs-lrg-controls-next"),
      prevArrow: $(this).parent().find(".hs-lrg-controls-prev"),
      customPaging: function (slick, i) {
        // Create the dot element
        var $dot = $("<button>" + (i < 10 && "0") + (i + 1) + "</button>");

        // Append the dot to the custom dots container
        $dot.appendTo($dotsContainer);

        // Bind a click event to the dot
        $dot.on("click", function () {
          // Update the Slick Slider to the corresponding slide
          slick.slickGoTo(i);
        });

        // Return the dot element
        return $dot;
      },
      // remove customPaging dots on mobile
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
          },
        },
      ],
    });

    $(this)
      .on("beforeChange", function () {
        $(this).find(".hs-lrg-slide-content").hide().removeClass("aos-animate");
      })
      .on("afterChange", function () {
        $(this).find(".hs-lrg-slide-content").show().addClass("aos-animate");
      });
  });

  AOS.init({
    duration: 500,
    offset: 150,
    once: true,
  });

  function filterPosts(status, type, page) {
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "filter_posts",
        status: status,
        project_type: type,
        page: page,
      },
      success: function (response) {
        // Clear the grid
        $(".all_posts_list").html("");

        // Append the new posts to the grid
        $(".all_posts_list").append(response);

        // Check if there are more posts available
        if ($(response).filter(".post-card").length < 8 * page) {
          // Hide the "Load More" button
          $(".load-more").hide();
        } else {
          // Show the "Load More" button
          $(".load-more").show();
        }
      },
    });
  }

  $(".status_category").on("click", function () {
    var status = $(this).data("status");
    var currentURL = new URL(window.location.href);
    currentURL.searchParams.set("status", status);
    window.history.pushState({ path: currentURL.href }, "", currentURL.href);

    var page = currentURL.searchParams.get("offset")
      ? currentURL.searchParams.get("offset")
      : 1;

    var type = currentURL.searchParams.get("type")
      ? currentURL.searchParams.get("type")
      : "all";

    filterPosts(status, type, page);

    $(".status_category").removeClass("active");
    $(this).addClass("active");
  });

  $(".type-select")
    .select2({
      minimumResultsForSearch: Infinity,
      placeholder: "Type",
    })
    .on("change", function () {
      var selectedValue = $(this).val();
      var currentURL = new URL(window.location.href);
      currentURL.searchParams.set("type", selectedValue);
      window.history.pushState({ path: currentURL.href }, "", currentURL.href);

      var page = currentURL.searchParams.get("offset")
        ? currentURL.searchParams.get("offset")
        : 1;

      var status = currentURL.searchParams.get("status")
        ? currentURL.searchParams.get("status")
        : "current";

      filterPosts(status, selectedValue, page);
    });

  $(".load-more").on("click", function (e) {
    e.preventDefault();

    var currentURL = new URL(window.location.href);

    var page = currentURL.searchParams.get("offset")
      ? currentURL.searchParams.get("offset")
      : $(this).data("page");

    var newPage = parseInt(page) + 1;
    var ajaxUrl = ajax_params.ajax_url;

    var type = currentURL.searchParams.get("type")
      ? currentURL.searchParams.get("type")
      : "all";
    var status = currentURL.searchParams.get("status")
      ? currentURL.searchParams.get("status")
      : "current";

    $.ajax({
      url: ajaxUrl,
      type: "post",
      data: {
        action: "load_more_posts",
        page: page,
        type: type,
        status: status,
      },
      beforeSend: function () {
        $(".load-more").text("Loading...");
      },
      success: function (response) {
        $(".load-more").text("Load more");
        // Append the new posts to the grid
        $(".all_posts_list").append(response);
        // Update the "Load more" button with the new page number
        $(".load-more").data("page", newPage);
        // Update the URL with the "paged" query parameter
        var currentURL = new URL(window.location.href);
        currentURL.searchParams.set("offset", newPage);
        window.history.pushState(
          { path: currentURL.href },
          "",
          currentURL.href
        );
        // Check if there are more posts available
        if ($(response).filter(".post-card").length < 8) {
          // Hide the "Load More" button
          $(".load-more").hide();
        } else {
          // Show the "Load More" button
          $(".load-more").show();
        }
      },
    });
  });

  $(".single-gallery").each(function () {
    $(this)
      .find(".popup-link")
      .magnificPopup({
        type: "image",
        mainClass: "mfp-zoom-in",
        gallery: {
          enabled: true,
        },
        callbacks: {
          open: function () {
            this.wrap.addClass("mfp-zoom-in");
          },
          close: function () {
            this.wrap.removeClass("mfp-zoom-in");
            this.wrap.addClass("mfp-zoom-out");
          },
        },
      });
  });

  $("body").on("click", ".ni-post-card", function () {
    $(this).find(".link")[0].click();
  });

  $(".info-cards .post-card").on("click", function () {
    $(this).find(".post-card-inner").toggleClass("active");
    let anchor = $(this).find("button");
    if (!$(this).data("initialText")) {
      $(this).data("initialText", anchor.text());
    }
    let initialText = $(this).data("initialText");
    anchor.text(anchor.text() === initialText ? "Close" : initialText);
  });
};

// Initialize each block on page load (front end).
$(window).on("load", function () {
  initializeBlock();
  if ($(".yoe").length) {
    yoePositioning();
  }

  // if window width is 992px or less
  if ($(window).width() <= 992) {
    singleBannerMobileSizing();
  }

  if ($(".type-select").length) {
    // Get the value of the "type" query string parameter
    var type = new URL(window.location.href).searchParams.get("type");

    // If the "type" query string parameter is set, set the value of the select2 element
    if (type) {
      $(".type-select").val(type).trigger("change.select2");
    }
  }
});

$(window).on("resize", function () {
  singleBannerMobileSizing();
});

function singleBannerMobileSizing() {
  if ($(window).width() <= 992) {
    var height = $(".hs-lrg-slide-content-inner").height();
    $(".single-work-banner-image").css(
      "padding-top",
      `calc(${height}px + 65%)`
    );
  } else {
    $(".single-work-banner-image").css("padding-top", "65%");
  }
}

function yoePositioning() {
  var link = $(".yoe").parent().find(".link");
  var element = $(".yoe");
  link.before(element);
  element.before(link);
}

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

var countUpExecuted = false;

function countUp() {
  var target = $(".yoe-inner > span:first-child").text();
  var count = 0;
  var interval = setInterval(function () {
    count++;
    if (count <= target) {
      $(".yoe-inner > span:first-child").text(count);
    } else {
      clearInterval(interval);
    }
  }, 50);
}

$(window).on("scroll", function () {
  if ($(".yoe").length) {
    if ($(".yoe").isInViewport() && !countUpExecuted) {
      countUp();
      countUpExecuted = true;
    }
  }
});
